
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/survey/aep/landing",
      function () {
        return require("private-next-pages/account/survey/aep/landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/survey/aep/landing"])
      });
    }
  